<template>
    <div class="auth-required-dlg">
        <el-dialog title="密码检测"
                   :visible="pwdIsEasy"
                   :show-close="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <div class="tips">
                对不起，您的密码设置过于简单，请重新设置密码。
            </div>
            <div class="op">
                <button class="btn btn-primary" @click="auth">前往设置密码</button>
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    import {mapState, mapMutations} from 'vuex'
    import changePswForm from './ChangePassword.vue'

    export default{
        props: {

        },
        computed: {
            ...mapState([
                'pwdIsEasy',
            ])
        },
        data(){
            return {
            }
        },
        methods: {
            ...mapMutations([
                'SET_PWD_STATUS'
            ]),
            auth(){
                this.$layer.dialog({
                    title: '重置密码',
                    component: changePswForm,
                    width:'500px',
                    data:{
                        isInDialog: true
                    },
                    confirm: (result) => {
                        this.SET_PWD_STATUS(false)
                    }
                })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .auth-required-dlg {
        .el-dialog__body{
            padding:20px;

            .tips{
                text-indent: 2em;
            }
            .op{
                padding: 20px 0;
                text-align: center;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/modules/account/CheckPassword.vue